<template>
  <div class="d-flex align-center flex-wrap mb-md-6 mb-3 mr-3" :class="onlyHeader ? 'justify-space-between' :''">
    <h1 class="page-title" v-html="title"></h1>

    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "PageTitle",
  props: {
    title: {},
    onlyHeader: { type: Boolean, default: false },
  },
};
</script>
